import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowPathUp"><Path d="M2.79688 11H8.00064V22H16.0006V11H21.2044L12.0006 0.481445L2.79688 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathUp;
